<script lang="ts" setup>
import { computed, provide } from 'vue'
import { VRow } from 'vuetify/components/VGrid'

import { layoutKey } from './utils'
import KamaRow from '../KamaGrid/KamaRow.vue'
import LayoutGrid from '../LayoutGrid/LayoutGrid.vue'

import type { LayoutVariant } from './utils'
import type { IGridAreas } from '@/types/serverGrid.type'

const props = withDefaults(defineProps<{
  grid?: IGridAreas | null
  activeAreas?: (string | undefined)[]
  variant?: LayoutVariant
  ignoreLayout?: boolean
}>(), { grid: null, activeAreas: undefined, variant: 'kama', ignoreLayout: false })

const useGrid = computed(() => Boolean(props.grid) && !props.ignoreLayout)
const activeAreas = computed(() => props.activeAreas?.filter((area): area is string => Boolean(area)))

provide(layoutKey, computed(() => ({
  useGrid: useGrid.value,
  variant: props.variant,
  ignoreLayout: props.ignoreLayout
})))
</script>

<template>
  <LayoutGrid
    v-if="useGrid && grid"
    :areas="grid"
    :active-areas="activeAreas"
  >
    <slot />
  </LayoutGrid>
  <Component
    :is="variant === 'vuetify' ? VRow : KamaRow"
    v-else
  >
    <slot />
  </Component>
</template>
